import { useMutation, useQueryClient } from '@tanstack/react-query';
import { JudgeDutyWriteRequest } from '~/apis/ssf';
import { keys } from './queries';
import { SSF } from '~/apis/api';

export function useCreateRefereeDutyMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async ({ payload }: { payload: JudgeDutyWriteRequest }) => {
      return await SSF.api.judgeDutiesCreate({
        ...payload,
      });
    },
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: keys.lists(),
      });
    },
  });
}

export function useDeleteRefereeDutyMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (variables: Parameters<typeof SSF.api.judgeDutiesDestroy>[0]) => SSF.api.judgeDutiesDestroy(variables),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}
